// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
import * as helper from './../../../Assets/Js/helper';

import {FontAwesomeLoader} from "./FontAwesomeLoader";
import {initImprint} from '../../../Assets/Js/VXImprint';
import {initMobileMenu} from "../../../Assets/Js/VXProductLight/MobileMenu";
import {initCookieBanner} from "../../../Assets/Js/VXProductLight/CookieBanner";
import {Menu} from "./Menu";
import {ChatButtons} from "./ChatButtons";
import {SoundButton} from "./SoundButton";
import {Chat} from "./Chat";
import {ChatInput} from "./ChatInput";
import {VideoHandler} from "./VideoHandler";
import {SmilyHandler} from "./SmilyHandler";
import {IPaytourOptions} from "../../../Assets/Js/paytour/PaytourHelperClass";

require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
require('babel-polyfill');

helper.onWindowLoadedCompletely(() => {
	const paytour = (window as any).paytourHelper;

	FontAwesomeLoader();
	initCookieBanner();
	Menu();
	Chat();
	ChatButtons();
	ChatInput();
	SoundButton();
	VideoHandler();

	const wrapper = helper.$('#wrapper');
	const extender = helper.getData(wrapper, 'extend');
	const sender = parseInt(helper.getData(wrapper, 'host'));
	const loginButton = document.querySelector('.header-buttons-login');
	const isVxWorld = window.location.host.match(/visit-x\.world/) !== null;
	const bonusCode = helper.getData(wrapper, 'bonus');
	const hasAVSCookie = parseInt(helper.getData(wrapper, 'cookie'), 10);

	const smileyButton: HTMLImageElement = document.querySelector('.model-chat-input-img.smiley');
	const smileyPreview: HTMLDivElement = document.querySelector('#smilypreview');
	new SmilyHandler(smileyButton, smileyPreview);

	const paytourSettings: IPaytourOptions = {
		lpId: 'ProfileChat',
		hideSignupConfirmation: true,
		targetUrl: '',
		pfm: 1502,
		host: sender,
		hideClose: false,
		disableJump: true,
	};

	switch (bonusCode) {
		case '10MVX4F':
		case '10EVX4F':
			paytourSettings.option = bonusCode;
			paytourSettings.pc = bonusCode;
			break;
		default:
			paytourSettings.option = bonusCode;
	}

	if (hasAVSCookie === 1) {
		// @ts-ignore
		paytourSettings.signupParams = {
			az: true
		};
	}

	const targetUrl = helper.getData(wrapper, 'target');
	const ab1 = parseInt(helper.getData(wrapper, 'ab1'));
	const links = helper.$('.paytour, .myphotos-item, .myvideos-item');

	if (sender === 4066266 && ['FannyPH2', 'FannyXV2', 'FannyXH2'].indexOf(bonusCode) !== -1) {
		// @ts-ignore
		paytourSettings.texts = {
			BonusTextCustom: '& erhalte 2 Videos geschenkt',
			BonusTextCustomSecondary: 'Erhalte 2 exklusive Hardcore-Videos geschenkt',
			SignupActorAttraction: 'Schnell & unverbindlich anmelden! Erhalte Zugang zu all meinen versauten Videos und zu geilen Livechats mit mir!',
		};
		// @ts-ignore
		paytourSettings.successUrl = 'https://www.visit-x.net/de/meinvisitx/videos-geschenkt/';
		helper.hide(document.querySelector('.nav-phone'));
		helper.hide(document.querySelector('#othergirls'));
	}

	if (bonusCode === '10EVX4F') {
		// @ts-ignore
		paytourSettings.texts = {
			BonusTextCustomSecondary: 'Erhalte Freiminuten im Wert von 10€ geschenkt! Finde deine Favoritin und lege direkt los',
		}
	}

	for (let link of links) {
		if (!helper.hasClass(link, 'nopaytour')) {
			if (isVxWorld && link === loginButton) {
				helper.addClickListener(loginButton, (evt: MouseEvent) => {
					evt.preventDefault();
					window.location.href = 'https://www.visit-x.net?vxpAutoFlow=Login&s=' + sender + '&' + extender;
				});
			} else {
				helper.addEventListener(link, 'click', (evt: MouseEvent) => {
					evt.preventDefault();
					if (paytourSettings.pc === '10MVX4F' || paytourSettings.pc === '10EVX4F') {
						paytour.openSignup(paytourSettings);
					} else if (paytourSettings.option === '2XITGA') {
						paytour.openPaytour(paytourSettings);
					} else {
						switch (ab1) {
							case 2:
								window.location.href = targetUrl;
								break;
							case 1:
								paytour.openSignup(paytourSettings);
								break;
							case 0:
							default:
								paytour.openPaytour(paytourSettings);
						}
					}
				})
			}
		}
	}

	const video = helper.$('#video');
	const videoContainer = helper.$('#videoContainer');
	const videoPlaybutton = helper.$('#videoPlay');
	const preview = helper.$('#preview');

	helper.addEventListener(video, 'ended', () => {
		helper.hide(videoContainer);
		helper.show(videoPlaybutton, 'flex');
		helper.show(preview);
	})

	helper.addEventListener(videoPlaybutton, 'click', (evt: MouseEvent) => {
		evt.preventDefault();
		helper.show(videoContainer);
		helper.hide(videoPlaybutton)
		helper.hide(preview);
		video.play();
	})

	const imprintlink = helper.$('#impressumlink');
	const dsgvolink = helper.$('#datenschutzlink');

	initImprint(imprintlink, dsgvolink);
	initMobileMenu();
})
